import { Popup } from "react-map-gl";

const formatNtaName = (nta) => nta.replace("-", " / ");
const formatElectionDistrict = (ed) =>
  ed.toString().slice(0, 2) + "/" + ed.toString().slice(2, 5);

export const MapPopup = ({ hoverInfo, isTurnoutMap }) => {
  const { latitude, longitude, districtData } = hoverInfo;
  const totalVotes = districtData.dem + districtData.rep + districtData.other;
  return (
    <Popup
      longitude={longitude}
      latitude={latitude}
      closeButton={false}
      className="county-info"
      closeOnClick={false}
    >
      <div className="popup-content">
        <div className="report">
          {totalVotes < 10 ? (
            <>
              <h3>
                Election District: {formatElectionDistrict(districtData.ed)}
              </h3>
              <p>
                {totalVotes === 0
                  ? `We're still trying to get this data, check back later!`
                  : totalVotes === 1
                  ? `We're still trying to get this data, check back later!`
                  : `We're still trying to get this data, check back later!`}
              </p>
            </>
          ) : isTurnoutMap ? (
            <>
              <h3>
                Election District: {formatElectionDistrict(districtData.ed)}
              </h3>
              {/* <p>
                2022 Turnout:{" "}
                {districtData.t22
                  ? Math.abs(Math.round(districtData.t22 * 10) / 10)
                  : "0"}
                %
              </p> */}
              {/* <br /> */}

              <p>
                <b>Neighborhood:</b> {formatNtaName(districtData.nta)}
              </p>
              <br />
              <table className="results">
                <thead>
                  <tr>
                    <th>Candidate</th>
                    <th className="number">'20 PCT</th>
                    <th className="number">'24 PCT</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <svg width="16" height="16" transform="translate(0,4)">
                        <circle fill="#466ab4" cx="8" cy="8" r="6"></circle>
                      </svg>{" "}
                      Biden/Harris
                    </td>
                    <td className="number">
                      {districtData.dem20
                        ? `${Math.round(
                            (districtData.dem20 * 100) /
                              (districtData.dem20 + districtData.rep20)
                          )}%`
                        : "N/A"}
                    </td>

                    <td className="number">
                      {districtData.dem
                        ? Math.round(
                            (districtData.dem * 100) /
                              (districtData.dem + districtData.rep + districtData.other)
                          )
                        : "0"}
                      %
                    </td>
                    {/* <td className="number">
                      {districtData.dem
                        ? `${Math.round(
                            (districtData.dem * 100) /
                              (districtData.dem + districtData.rep)
                          )}%`
                        : "N/A"}
                    </td> */}
                  </tr>
                  <tr>
                    <td>
                      <svg width="16" height="16" transform="translate(0,4)">
                        <circle fill="#d43e4a" cx="8" cy="8" r="6"></circle>
                      </svg>{" "}
                      Trump
                    </td>
                    {/* <td className="number">
                      {districtData.rep20
                        ? Math.round(
                            (districtData.rep20 * 100) /
                              (districtData.dem20 + districtData.rep20)
                          )
                        : "0"}
                      %
                    </td> */}
                    <td className="number">
                      {districtData.rep20
                        ? `${Math.round(
                            (districtData.rep20 * 100) /
                              (districtData.dem20 + districtData.rep20)
                          )}%`
                        : "N/A"}
                    </td>
                    <td className="number">
                      {districtData.rep
                        ? Math.round(
                            (districtData.rep * 100) /
                              (districtData.dem + districtData.rep + districtData.other)
                          )
                        : "0"}
                      %
                    </td>
                  </tr>
                  {/* <tr>
                    <td>Change</td>
                    <td className="number">
                      {districtData.nta18 && districtData.nta22
                        ? Math.round(
                            (districtData.nta22 - districtData.nta18) * 10
                          ) / 10
                        : "0"}
                      %
                    </td>
                  </tr> */}
                </tbody>
              </table>
            </>
          ) : (
            <>
              <h3>
                Election District: {formatElectionDistrict(districtData.ed)}
              </h3>
              <p>
                <b>Neighborhood:</b> {formatNtaName(districtData.nta)}
              </p>
              <table className="results">
                <thead>
                  <tr>
                    <th>Candidate</th>
                    <th>Party</th>
                    <th className="number">Votes</th>
                    <th className="number">Pct.</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <svg width="16" height="16" transform="translate(0,4)">
                        <circle fill="#466ab4" cx="8" cy="8" r="6"></circle>
                      </svg>{" "}
                      Harris
                    </td>
                    <td>DEM</td>
                    <td className="number">{districtData.dem}</td>
                    <td className="number">
                      {totalVotes !== 0
                        ? (districtData.dem / totalVotes).toLocaleString(
                            "en-US",
                            {
                              style: "percent",
                              maximumFractionDigits: 1,
                              minimumFractionDigits: 1,
                            }
                          )
                        : "0%"}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <svg width="16" height="16" transform="translate(0,4)">
                        <circle fill="#d43e4a" cx="8" cy="8" r="6"></circle>
                      </svg>{" "}
                      Trump
                    </td>
                    <td>REP</td>
                    <td className="number">{districtData.rep}</td>
                    <td className="number">
                      {totalVotes !== 0
                        ? (districtData.rep / totalVotes).toLocaleString(
                            "en-US",
                            {
                              style: "percent",
                              maximumFractionDigits: 1,
                              minimumFractionDigits: 1,
                            }
                          )
                        : "0%"}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <svg width="16" height="16" transform="translate(0,4)">
                        <circle fill="black" cx="8" cy="8" r="6"></circle>
                      </svg>{" "}
                      Other
                    </td>
                    <td></td>
                    <td className="number">{districtData.other}</td>
                    <td className="number">
                      {totalVotes !== 0
                        ? (districtData.other / totalVotes).toLocaleString(
                            "en-US",
                            {
                              style: "percent",
                              maximumFractionDigits: 1,
                              minimumFractionDigits: 1,
                            }
                          )
                        : "0%"}
                    </td>
                  </tr>
                </tbody>
              </table>
            </>
          )}
        </div>
      </div>
    </Popup>
  );
};
